export const REQUIRED_PRODUCT = [
	'pName','pDisplayName','barCode','pricePerUnit','units','pQuantity',
	'pTotalPrice','maxStock','pInStock','pLowStock',
	'pFulfillment','pStatus','pDeliveryOption','pShippingWeight'
];

export const PRODUCT_FIELD_LABELS = {
	pName: 'Product name',
	pDisplayName: 'Display name',
	barCode: 'Barcode',
	pricePerUnit: 'Price per unit',
	units: 'Units',
	pQuantity: 'Quantity',
	pTotalPrice: 'Total price',
	maxStock: 'Max stock',
	pInStock: 'In stock',
	pLowStock: 'Low stock',
	pFulfillment: 'Fulfillment',
	pStatus: 'Product status',
	pDeliveryOption: 'Delivery option',
	pShippingWeight: 'Shipping weight',
};

export const requiredMessage = (key) =>
	`${PRODUCT_FIELD_LABELS[key] || key} is required.`;

export function validateProduct(state){
	const missing = REQUIRED_PRODUCT.filter(k=>{
		if(Array.isArray(state[k])) return state[k].length===0;
		return !state[k] && state[k]!==0;           // allow “0” as valid number
	});
	return {
		ok: missing.length===0,
		missing
	};
}